import { render } from "./createOpportunity.vue?vue&type=template&id=5efa0d6e"
import script from "./createOpportunity.vue?vue&type=script&lang=js"
export * from "./createOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__